<template>
  <div class="row">
    <div class="col-sm-12 col-lg-4">
      <h3>{{ $t('welcome.newsletter.title')}}</h3>
      <p>{{ $t('welcome.newsletter.text')}}</p>
    </div>
    <div class="col-sm-12 col-lg-4">
      <template v-if="thankyou">
        <h3>{{ $t('general.newsletter.thankyou_2')}}</h3>
      </template>
      <template v-else>
        <div :class="['input-group', {'is-invalid': errors.has('name')}]">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="icon icon-user"></i>
            </div>
          </div>
          <input class="form-control" name="name" v-model="form.name" :placeholder="$t('welcome.newsletter.form.name')" />
          <div v-if="errors.has('name')" class="invalid-feedback">{{ errors.get('name') }}</div>
        </div>
        <div :class="['input-group', {'is-invalid': errors.has('email')}]">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="icon icon-e-news"></i>
            </div>
          </div>
          <input class="form-control" name="email" v-model="form.email" type="email" :placeholder="$t('welcome.newsletter.form.email')" />
          <div v-if="errors.has('email')" class="invalid-feedback">{{ errors.get('email') }}</div>
        </div>
      </template>
    </div>
    <div class="col-sm-12 col-lg-4">
      <div class="form-group">
        <div class="checkbox">
          <label>
            <input name="confirm" v-model="form.confirm" value="1" type="checkbox" />
            <span :class="['left', {'is-invalid': errors.has('confirm')}]" v-html="$t('welcome.newsletter.form.privacy')"></span>
          </label>
        </div>
        <div v-if="errors.has('confirm')" class="invalid-feedback">{{ errors.get('confirm') }}</div>
      </div>
      <button type="sumbit" class="btn btn-green w-100" @click.prevent="submit">{{ $t('welcome.newsletter.form.btn') }}</button>
    </div>
  </div>
</template>

<script>
import Errors from '@Core/errors'
import XHR from '@Core/xhr'
import to from '@Utils/to'

export default {

  data () {
    return {
      thankyou: false,
      errors: new Errors(),
      form: new XHR({
        name: '',
        email: '',
        confirm: ''
      })
    }
  },

  methods: {
    async submit () {
      let [errors, response] = await to(this.form.post('/newsletter'))

      this.errors = errors || new Errors()
      !errors && response.success && this.showThankyou() && this.form.reset()
    },

    showThankyou () {
      this.thankyou = true
      setTimeout(() => { this.thankyou = false }, 4000)

      return true
    }
  }

}
</script>
